import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const usePrimarySellerLabelProviderIdForService = (serviceId) => {
  const sellerLabelProviderId = useSelector((state) => {
    return Global.selectSellerServiceById(state, { serviceId })?.sellerLabelProviderId;
  });

  const sellerLabelProviders = useSelector((state) => {
    return Global.selectSellerLabelProviders(state);
  });

  if (!serviceId || !sellerLabelProviderId) {
    return;
  }

  const sellerLabelProvider = sellerLabelProviders.find((slp) => slp.sellerLabelProviderId === sellerLabelProviderId);

  const primarySellerLabelProvider = sellerLabelProviders.find(
    (slp) => slp.labelProviderId === sellerLabelProvider?.labelProviderId && slp.isPrimaryAccount,
  );

  return primarySellerLabelProvider?.sellerLabelProviderId || sellerLabelProviderId?.sellerLabelProviderId;
};
